export default "__VITE_ASSET__DaheWy3h__"